import Head from "next/head";
import Image from "next/image";
import { Container } from "~/components/layout/Container";
import Button from "~/components/ui/Button/Button";
import fetchJson from "~/lib/fetchJson";
import useUser from "~/lib/useUser";

import Link from "next/link";
import { useRouter } from "next/router";
import { type ReactElement } from "react";
import { useAccount } from "wagmi";
import Layout from "~/components/layout/Layout";
import EVMWallet from "~/components/wallet/evm/EVMWallet";

const Home = () => {
  const { user, mutateUser } = useUser();
  const { push } = useRouter();

  const { isConnected } = useAccount();

  const logout = async () => {
    await mutateUser(
      await fetchJson("/api/auth/logout", { method: "GET" }),
      false
    );
    void push("/");
  };

  return (
    <>
      <Head>
        <title>RFOX VALT | Login</title>
      </Head>
      <Container>
        <div className="Container relative mx-auto mt-20 flex h-screen w-full justify-center">
          <div className="center absolute mx-4 h-fit items-center rounded-lg bg-dark-200 px-10 py-10 md:px-16 md:py-16">
            <h3 className="text-center text-2xl font-bold italic leading-6 text-light-50 md:text-4xl">
              Connect Your Account
            </h3>
            <p className="mt-2 max-w-2xl text-center text-sm text-light-250 md:mt-4  md:text-base">
              Login/ Sign up to RFOX ID With Your Favorite Social Media Account
            </p>

            <Image
              src="/images/rfox-id.svg"
              alt="rfox-id"
              width={120}
              height={40}
              className="mx-auto mt-6"
            />

            <div className="mx-auto flex w-fit flex-col justify-center">
              <p className="mb-4 text-xs font-semibold text-light-200">
                {user?.playfabId ? user.playfabId : user?.id}
              </p>

              <Button intent={"primary"} onClick={logout}>
                Logout
              </Button>
            </div>

            <div className="mx-auto mt-4 flex max-w-md flex-col gap-2">
              <div className="inline-flex w-full items-center justify-center">
                <hr className="my-8 h-px w-full border-0 bg-light-250" />
                <span className="absolute left-1/2 -translate-x-1/2 bg-dark-200 px-3 font-medium text-light-250 ">
                  Link and Verify your wallet
                </span>
              </div>

              <EVMWallet />

              <Button width={"full"} intent={"secondary"} outline={true}>
                <Image
                  src="/images/wax-logo.svg"
                  alt="rfox-id-wax"
                  width={40}
                  height={15}
                  className="mr-3"
                />
                Wax Wallet
              </Button>

              <Link href={isConnected ? "/nft" : "/profile"}>
                <Button width={"full"} intent={"primary"}>
                  Continue
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

Home.getLayout = function getLayout(page: ReactElement) {
  return <Layout publicAccess={true}>{page}</Layout>;
};

export default Home;
